import { router } from "@inertiajs/svelte"
import { createConsumer } from "@rails/actioncable"

const consumer = createConsumer()

export function subscribeToDashboardChannel(
  onMessage: (data: { type: string; data: Record<string, unknown> }) => void,
) {
  return consumer.subscriptions.create(
    {
      channel: "DashboardChannel",
    },
    {
      received(data: unknown) {
        const message = data as { type: string; data: Record<string, unknown> }
        onMessage(message)
        router.reload({ only: ["awaitingApproval", "currentlyAssigned", "adHocAvailable", "unpaidCompleted", "financialSummary", "canTurnOverWeek"] })
      },
    },
  )
}

export function subscribeToUserDashboardChannel(
  onMessage: (data: { type: string; data: Record<string, unknown> }) => void,
) {
  return consumer.subscriptions.create(
    {
      channel: "UserDashboardChannel",
    },
    {
      received(data: unknown) {
        const message = data as { type: string; data: Record<string, unknown> }
        onMessage(message)
        router.reload({ only: ["assignedTasks", "availableTaskTemplates", "recentTasks", "wageSummary"] })
      },
    },
  )
}
